// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"370":"f0553a7e","560":"3c5cb89a"}[chunkId] + ".chunk.css";
};